import * as React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';

import { withRouter, RouteComponentProps } from 'react-router-dom';

import {
  TextField,
  Tab,
  Tabs,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  ExpansionPanelActions,
  IconButton
} from '@material-ui/core';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import BackIcon from '@material-ui/icons/ArrowBack';
import UserProvider, { UpdateUserFn } from '../providers/UserProvider';
import { firebaseLogout } from '../services';

const styles: StyleRulesCallback = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh'
  },
  content: {
    padding: theme.spacing.unit * 3,
    flex: 1,
    overflowY: 'scroll',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15)
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20
  },
  details: {
    alignItems: 'center'
  },
  column: {
    flexBasis: '33.33%'
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
});

interface State {
  tab: string;
  firstName: string | null;
  lastName: string | null;
}

type Props = WithStyles & RouteComponentProps<any>;

class UserProfile extends React.Component<Props, State> {
  state = {
    tab: 'session',
    firstName: null,
    lastName: null,
  };

  handleLogout = async () => {
    await firebaseLogout();
    this.props.history.push('/login');
  }

  handleSaveProfile = (user: User | null, updateUser: UpdateUserFn | null) => {
    const firstName = !this.state.firstName && user ? user.firstName : this.state.firstName;
    const lastName = !this.state.lastName && user ? user.lastName : this.state.lastName;
    if (updateUser && firstName && lastName) {
      updateUser(firstName, lastName);
    }
  }

  handleChangeTab = (event: any, tab: string) => {
    this.setState({ tab });
  }

  renderSession(user: User | null, updateUser: UpdateUserFn | null, updating: boolean) {
    const { classes } = this.props;

    return (
      <Grid container={true} spacing={24} style={{ maxWidth: 900 }}>
        <Grid item={true} xs={12}>
          <ExpansionPanel defaultExpanded={true}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>
                Cerrar Sesión
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Typography>
                Seleccione esta opción si desea cerrar la sesión. Sus
                datos permanecerán intactos, pero deberá ingresar su
                usuario y contraseña nuevamente para poder acceder a
                ellos.
              </Typography>
            </ExpansionPanelDetails>
            <Divider />
            <ExpansionPanelActions>
              <Button size="small" onClick={this.handleLogout}>Cerrar sesión</Button>
            </ExpansionPanelActions>
          </ExpansionPanel>
        </Grid>
      </Grid>
    );
  }

  renderProfile(user: User | null, updateUser: UpdateUserFn | null, updating: boolean) {
    const { classes } = this.props;
    const firstName = (!this.state.firstName && user ? user.firstName : this.state.firstName) || '';
    const lastName = (!this.state.lastName && user ? user.lastName : this.state.lastName) || '';

    return (
      <Grid container={true} spacing={24} style={{ maxWidth: 900 }}>
        <Grid item={true} xs={12}>
          <ExpansionPanel defaultExpanded={true}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>
                Información
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{flexDirection: 'column'}}>
              <TextField
                fullWidth={true}
                margin="normal"
                label="Nombre"
                value={firstName}
                onChange={e => this.setState({firstName: e.target.value})}
                disabled={updating}
              />
              <TextField
                fullWidth={true}
                margin="normal"
                label="Apellido"
                value={lastName}
                onChange={e => this.setState({lastName: e.target.value})}
                disabled={updating}
              />
              <TextField
                fullWidth={true}
                margin="normal"
                label="Email"
                value={user ? user.email || '' : ''}
                disabled={true}
              />
            </ExpansionPanelDetails>
            <Divider />
            <ExpansionPanelActions>
              <Button
                size="small"
                disabled={updating}
                onClick={() => this.handleSaveProfile(user, updateUser)}
              >
                Guardar cambios
              </Button>
            </ExpansionPanelActions>
          </ExpansionPanel>
        </Grid>
      </Grid>
    );
  }

  renderTabs(user: User | null, updateUser: UpdateUserFn | null, updating: boolean) {
    switch (this.state.tab) {
      case 'session':
        return this.renderSession(user, updateUser, updating);
      case 'profile':
        return this.renderProfile(user, updateUser, updating);
      default:
        return null;
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <UserProvider>
        {(user, loading, updateUser, updating) => (
          <main className={classes.root}>
            <AppBar position="static" elevation={0}>
              <Toolbar>
                <IconButton
                  onClick={() => this.props.history.goBack()}
                  style={{marginRight: 8, color: '#FFF'}}
                >
                  <BackIcon />
                </IconButton>
                <Typography variant="title" color="inherit" noWrap={true}>
                  {user && `${user.firstName} ${user.lastName}`}
                </Typography>
              </Toolbar>
              <Tabs value={this.state.tab} onChange={this.handleChangeTab}>
                <Tab value="session" label="Sesión" />
                <Tab value="profile" label="Mi Perfil" />
                <Tab value="payment" label="Medio de pago" />
              </Tabs>
            </AppBar>
            <div className={classes.content}>
              {this.renderTabs(user, updateUser, updating)}
            </div>
          </main>
        )}
      </UserProvider>
    );
  }
}

export default withStyles(styles)(withRouter(UserProfile));



// WEBPACK FOOTER //
// ./src/containers/Account.tsx